import React, { useEffect, useState } from 'react';
import { generatePresignedUrl } from './S3getSignedUrl';
import axios from 'axios';

const S3PrivateHtmlViewer = ({ filename }) => {
    const [iframeUrl, setIframeUrl] = useState('');
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        const loadSignedUrl = async () => {
            const url = await generatePresignedUrl(
                'oyster-lite',
                filename,
            );

            if (url) {

                try {
                    const response = await axios.get(url, {
                        method: "GET",
                        validateStatus: () => true, // don’t throw on 403
                    });

                    if (response.status === 200) {
                        console.log("URL is valid");
                        setIframeUrl(url);
                        setErrorMsg('');
                    } else {
                        console.log("URL invalid, status:", response.status);
                        setErrorMsg('Failed to load file or the file does not exist. Please try again later.');
                        setIframeUrl('');
                    }
                } catch (err) {
                    console.error("Error checking URL:", err);
                }
            } else {
                setErrorMsg('Failed to load file. Network error or invalid credentials.');
                setIframeUrl('');
            }
        };

        loadSignedUrl();
    }, [filename]);

    if (errorMsg) {
        return <div style={{ color: 'red' }}>{errorMsg}</div>;
    }
    if (!iframeUrl) {
        return <div className="text-black, dark:text-white">Loading...</div>;
    }

    return (
        iframeUrl && (
            <iframe
                src={iframeUrl}
                title="Private HTML from S3"
                style={{ width: '100%', height: '800px', border: 'none' }}
            />
        )
    );
};

export default S3PrivateHtmlViewer;